"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.excavatorTypes = void 0;
exports.excavatorTypes = {
    SET_DATA_GRID: 'EXCAVATOR TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'EXCAVATOR TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'EXCAVATOR TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'EXCAVATOR TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'EXCAVATOR TYPES ON SAVE DATAITEM',
    ON_FILTER_CHANGE: 'EXCAVATOR TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'EXCAVATOR TYPES ON SORT CHANGE',
    GET_DETAIL: 'EXCAVATOR TYPES ON GET DETAIL',
    ON_DELETE: 'EXCAVATOR TYPES ON DELETE',
    SET_ERROR: 'EXCAVATOR TYPES ON ERROR'
};
